import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ReleaseNoteComponent } from '../release-note.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@shared/components/components.module';
import { CoupleIdLite } from '@shared/models/generic/id/couple-id-lite.model';

@Component({
  selector: 'app-release-dialog',
  templateUrl: './release-dialog.component.html',
  imports: [ReleaseNoteComponent, MatButtonModule, MatDialogModule, TranslateModule, ComponentsModule],
})
export class ReleaseDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ReleaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public releases: CoupleIdLite[],
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
